import React from "react";
import Helmet from "react-helmet";
import {MetaDataInfo} from "./MetaDataInfo"
import PropTypes from "prop-types";
import heroImage from "../../Assets/Images/Hero/hourglass.svg";

class MetaData extends React.Component{
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {
        let {keyword} = this.props;
        let MetaData = MetaDataInfo[keyword];
        return (
            <Helmet>
                <meta charSet="utf-8" />
                <title>{MetaData.Title}</title>
                <meta name="description" content={MetaData.Description}/>
                <meta name="keywords" content={MetaData.Keywords}/>
                <meta httpEquiv="cleartype" content="on"/>
                <meta name="author" content="IP Agent AI"/>
                <meta name={MetaData.URL}
                      content={MetaData.URLKeys}/>
                <meta name="rating" content="General"/>
                <meta name="robots" content="index,follow,noarchive"/>
                <meta name="revisit-after" content="daily"/>
                <meta content="English" name="language"/>
                <meta property="og:type " content="website" />
                <meta property="og:title" content={MetaData.OGTitle} />
                <meta property="og:title locale" content="en_US" />
                <meta property="og:description" content={MetaData.Description}/>
                <meta property="og:url" content={MetaData.URL} />
                <meta property="og:site_name" content={"IP Agent AI"} />
                <link rel="canonical" href={MetaData.URL}/>
                {
                    keyword === "home" &&
                    <link rel="preload" as="image" fetchPriority={"high"} href={heroImage} type="image/svg"/>
                }
            </Helmet>
        );
    }
}

MetaData.defaultProps = {
    keyword: "home"
}

MetaDataInfo.propTypes = {
    keyword: PropTypes.string.isRequired
}

export default MetaData;